<script>
  let {
    action,
    children,
    subtitle,
    image_url,
    status,
    title,
    icon,
    default_icon,
  } = $props();
</script>

<div
  class="tw:group/card tw:relative tw:isolate tw:flex tw:h-40 tw:w-[375px] tw:shrink-0 tw:snap-center tw:flex-row tw:gap-4 tw:truncate tw:overflow-clip tw:rounded-2xl tw:bg-white tw:p-4 tw:shadow-sm tw:transition-colors"
>
  <div class="tw:-mt-4 tw:-mb-4 tw:-ml-4 tw:flex tw:w-32">
    {#if image_url}
      <img class="tw:object-cover" src={image_url} alt={title} />
    {:else}
      <div
        class="tw:flex tw:flex-1 tw:items-center tw:justify-center tw:bg-zinc-100 tw:object-cover"
      >
        {@render default_icon(icon)}
      </div>
    {/if}
    {#if status}
      <div
        class={[
          "tw:absolute tw:top-1 tw:left-1 tw:rounded-full tw:px-2 tw:py-1 tw:text-xs",
          status.color_class,
        ]}
      >
        {@html status.text}
      </div>
    {/if}
  </div>
  <div class="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col">
    <div class="tw:flex tw:flex-1 tw:flex-col tw:gap-2 tw:text-sm/4">
      <div>
        <h3 class="tw:truncate tw:text-xl tw:leading-5 tw:text-zinc-900">
          {title}
        </h3>
        {#if subtitle}
          {@render subtitle?.()}
        {/if}
      </div>
      {@render children?.()}
    </div>
    {#if action}
      <div class="tw:-mr-2 tw:-mb-2 tw:flex tw:justify-end">
        {@render action?.()}
      </div>
    {/if}
  </div>
  <div
    class="tw:pointer-events-none tw:absolute tw:inset-0 tw:rounded-2xl tw:ring tw:ring-zinc-950/5 tw:transition-all tw:ring-inset"
  ></div>
</div>
